<template>
  <div class="option_content">
    <router-link :to="`/liveMatchesTwo/${item.anchorid}`" v-for="(item, index) of anchorList" :key="item.anchorid">
      <span class="avatar">
        <img v-if="item.anchor_avatar.length > 0" :src="item.anchor_avatar" />
        <img v-else src="./anchor/avatar_default.png" />
        <span class="follow" @click.stop.prevent="followAchor(item.anchorid, index)">
          <img v-show="myFollowAnchors[index] == 0" src="./anchor/add.png" />
          <img v-show="myFollowAnchors[index] == 1" src="./anchor/added.png" />
        </span>
      </span>
      <div class="anchor_info">
        <h4>
          <strong>{{ item.anchor_name }}</strong>
          <span class="level"><img :src="require(`../../assets/img/anchor-levels/lv${item.level}.png`)" /></span>
          <span><img src="./img/starting.gif" /></span>
        </h4>
        <p>{{ item.title }}</p>
      </div>
      <div class="follow_users">
        <img src="./anchor/live_heat.png" />
        <span>{{ getFansNumber(item.hot) }}</span>
      </div>
    </router-link>
    <div v-if="anchorList.length == 0">
      <panel-not-data message="当前没有主播..." img-name="live" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { post } from "@/util/http";
//引入公用无数据组件
import PanelNotData from "@/components/match-recommend/not-data";

export default {
  name: "AnchorList",
  data() {
    return {
      //推荐主播列表
      anchorList: [],
      //当前主播的关注情况
      myFollowAnchors: [],
    };
  },
  components: {
    PanelNotData,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    ...mapActions(["getUserInfo"]),
    ...mapMutations(["toggleLogin"]),
    /**
     * 关注/取消关注当前主播
     * @param {Int} anchor_id 当前主播ID
     */
    followAchor(anchor_id, index) {
      // 如果未登陆
      if (!this.userInfo.id) {
        this.toggleLogin();
        return false;
      }
      post({
        url: "/api/anchor/attentAnchor",
        data: {
          anchorid: anchor_id,
        },
      }).then((res) => {
        // console.log("关注操作:", res.data.data);
        if (res.data.status == 0 && res.data.data.type == 1) {
          this.$set(this.myFollowAnchors, index, 1);
          this.$message({
            message: "关注成功！",
            type: "success",
          });
        } else {
          this.$set(this.myFollowAnchors, index, 0);
          this.$message({
            message: "您已取消关注！",
            type: "warning",
          });
        }
      });
    },
    /**
     * 获取推荐的主播
     */
    getRecommendAnchors() {
      post({
        url: "/api/home/getHomeUserRecLive",
        data: {
          size: 10,
        },
      }).then((res) => {
        // console.log("推荐主播：",res);
        if (res.data.status == 0 && res.data.data?.length > 0) {
          this.anchorList = res.data.data;
          this.anchorList.forEach((item, index) => {
            this.myFollowAnchors[index] = item.isattent;
          });
        }
      });
    },
    //计算并格式化数值
    getFansNumber(num) {
      if (num >= 10000) {
        num = Math.round(num / 1000) / 10 + "W";
      }
      return num;
    },
  },
  mounted() {
    this.getRecommendAnchors();
  },
};
</script>

<style lang="scss" scoped>
.option_content {
  clear: both;
  width: 100%;
  height: calc(100% - 72px);
  overflow: hidden;
  overflow-y: auto;

  //滚动条整体样式
  &::-webkit-scrollbar {
    width: 6px;
  }

  //滚动条里面小方块
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #535353;
  }

  //滚动条里面轨道
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  a {
    display: block;
    clear: both;
    width: 100%;
    height: 85px;
    overflow: hidden;
    box-sizing: border-box;
    padding: 20px 10px;
    position: relative;

    &:hover {
      background: linear-gradient(90deg, rgba(41, 240, 158, 0.1) 0%, rgba(3, 162, 249, 0.1) 100%), #f9f9fb;
    }

    .avatar {
      display: block;
      float: left;
      width: 48px;
      height: 48px;
      overflow: hidden;
      background: linear-gradient(to right, rgb(41, 241, 156), rgb(2, 161, 249));
      box-sizing: border-box;
      padding: 0.02rem;
      border-radius: 0.4rem;
      position: relative;

      & > img {
        display: block;
        min-width: 100%;
        height: 100%;
        border-radius: 0.4rem;
      }
      .follow {
        display: block;
        width: 0.2rem;
        height: 0.2rem;
        overflow: hidden;
        margin: 0 auto;
        position: absolute;
        z-index: 2;
        left: 0;
        right: 0;
        bottom: 0.02rem;
        img {
          display: block;
          width: 100%;
        }
      }
    }

    .anchor_info {
      float: left;
      width: 270px;
      height: 100%;
      overflow: hidden;
      box-sizing: border-box;
      padding: 0px 10px;

      h4,
      p {
        clear: both;
        width: 100%;
        height: 50%;
        line-height: 24px;
        overflow: hidden;
        font-size: 14px;
        color: #999;

        strong {
          display: inline-block;
          width: auto;
          height: 100%;
          overflow: hidden;
          font-size: 16px;
          color: #333;
        }

        span {
          display: inline-block;
          width: auto;
          height: 100%;
          overflow: hidden;

          img {
            height: 0.2rem;
          }
        }
        span.level {
          padding: 0px 0.05rem;
          img {
            height: 0.18rem;
          }
        }
      }

      h4 {
        span {
          vertical-align: top;
        }
      }

      p {
        text-overflow: ellipsis;
        word-break: break-all;
        white-space: nowrap;
      }
    }

    .follow_users {
      display: inline-block;
      width: auto;
      height: 0.2rem;
      line-height: 0.2rem;
      overflow: hidden;
      font-size: 0.14rem;
      color: gray;
      text-align: right;
      position: absolute;
      z-index: 2;
      right: 0.1rem;
      top: 0.25rem;
      img {
        display: inline-block;
        height: 0.18rem;
        vertical-align: top;
      }
      span {
        padding-left: 0.05rem;
      }
    }
  }

  a:nth-child(even) {
    background-color: #f9f9fb;
  }
}
</style>